import i18n from 'simple-react-i18n'

const IMPORT_FORMATS = () => [
    /* {
            value: 'aquasysPivEau',
            label: i18n.aquasysPivEau,
            type: 'import'
        },
        {
            value: 'checkPiezo',
            label: i18n.checkPiezo,
            type: 'import'
        },*/
    {
        value: 'catchmentTrend',
        label: i18n.catchmentTrend,
        type: 'calcul',
        description: i18n.calculHypeTrendNitratesPesticides,
        specify: false,
    },
    {
        value: 'wsAdesPiezo',
        label: i18n.wsAdesPiezo,
        type: 'import',
        description: i18n.usesAdesWebServiceImportPiezometers,
        specify: true,
    },
    {
        value: 'wsAdesQualito',
        label: i18n.wsAdesQualito,
        type: 'import',
        description: i18n.usesAdesWebServiceImportQualitometers,
        specify: true,
    },
    {
        value: 'importQuesu',
        label: i18n.importQuesu,
        type: 'import',
        specify: false,
    },
    {
        value: 'importQesoutPiezo',
        label: i18n.importQesoutPiezo,
        type: 'import',
        withFiles: true,
        specify: false,
    },
    {
        value: 'importQesoutQuality',
        label: i18n.importQesoutQuality,
        type: 'import',
        withFiles: true,
        specify: false,
    },
    {
        value: 'lowWater',
        label: i18n.lowWaterOnde,
        type: 'import',
        specify: true,
    },
    {
        value: 'importEdilabo',
        label: i18n.importEdilabo,
        type: 'import',
        specify: false,
    },
    {
        value: 'importEdilaboDAI',
        label: i18n.importEdilaboDAI,
        type: 'import',
        specify: false,
    },
    {
        value: 'ddassdistri',
        label: i18n.ddassdistri,
        type: 'import',
        specify: false,
    },
    {
        value: 'importPiveau',
        label: i18n.PIVEAU,
        type: 'import',
        description: 'Importe les données qualités d un fichier texte ou Excel en spécifiant les colonnes requises',
        specify: false,
    },
    {
        value: 'importRsde',
        label: i18n.RSDE,
        type: 'import',
        specify: false,
    },
    /* {
            value: 'meteofrance',
            label: i18n.meteofrance,
            type: 'import'
        },*/
    {
        value: 'synop',
        label: i18n.synop,
        type: 'import',
        specify: false,
    },
    {
        value: 'selfControl',
        label: i18n.selfControl,
        type: 'import',
        specify: false,
    },
    {
        value: 'ligura',
        label: i18n.ligura,
        type: 'import',
        specify: false,
    },
    {
        value: 'hydro',
        label: i18n.hydro,
        type: 'import',
        description: 'Importe les stations hydro depuis le site Hydro Portail : https://hydro.eaufrance.fr/',
        specify: true,
    },
    {
        value: 'tidegauge',
        label: i18n.tidegauge,
        type: 'import',
        specify: true,
    },
    {
        value: 'oceanogram',
        label: i18n.oceanogram,
        type: 'import',
        specify: false,
    },
    {
        value: 'surfaceQualitometer',
        label: i18n.surfaceQualitometer,
        type: 'import',
        specify: true,
    },
    // {
    //     value: 'hubeau',
    //     label: i18n.hubeau,
    //     type: 'import'
    // },
    {
        value: 'vigicrues',
        label: i18n.vigicrues,
        type: 'import',
        specify: false,
    },
    /* {
            value: 'SIAPLAB',
            label: i18n.SIAPLAB,
            type: 'import'
        },
        {
            value: 'ott',
            label: i18n.ott,
            type: 'import'
        },
        {
            value: 'diver',
            label: i18n.diver,
            type: 'import'
        },
        {
            value: 'paratronic',
            label: i18n.paratronic,
            type: 'import'
        },
        {
            value: 'ijinus',
            label: i18n.ijinus,
            type: 'import'
        },
        {
            value: 'excel',
            label: i18n.excel,
            type: 'import'
        },
        {
            value: 'csv',
            label: i18n.csv,
            type: 'import'
        },*/
    {
        value: 'csvAll',
        label: i18n.CSVGeneric,
        type: 'import',
        withFiles: true,
        description: 'Importe un fichier CSV ou Excel en spécifiant les colonnes requises',
        specify: false,
    },
    {
        value: 'synchro_city',
        label: i18n.cityCentersImport,
        type: 'import',
        specify: false,
    },
    {
        value: 'infoTerreBoreholesDepartment',
        label: i18n.InfoTerre,
        type: 'import',
        specify: false,
    },
    {
        value: 'seba',
        label: i18n.seba,
        type: 'import',
        withFiles: true,
        specify: false,
    },
    {
        value: 'paratronicLNSXML',
        label: i18n.paratronicLNSXML,
        type: 'import',
        withFiles: true,
        specify: false,
    },
    {
        value: 'MISfiles',
        label: i18n.MISfiles,
        type: 'import',
        withFiles: true,
        specify: false,
    },
    {
        value: 'processFileIAEau',
        label: i18n.processFileIAEau,
        description: 'Permet de traiter des fichiers via script Python ou R dans IAEau.',
        type: 'calcul',
        withFiles: true,
        specify: false,
    },
    {
        value: 'cemagref',
        label: i18n.cemagref,
        type: 'import',
        withFiles: true,
        specify: false,
    },
    {
        value: 'HUBEAUpiezo',
        label: i18n.HUBEAUpiezo,
        type: 'import',
        specify: false,
    },
    {
        value: 'HUBEAUquality',
        label: i18n.hubeauQuality,
        type: 'import',
        specify: false,
    },
    {
        value: 'hydrobio',
        label: i18n.hubeauHydrobio,
        type: 'import',
        specify: false,
    },
    {
        value: 'hydrobioNaiades',
        label: i18n.hydrobioNaiadesImport,
        type: 'import',
        specify: false,
    },
    {
        value: 'aspeHubeau',
        label: i18n.aspeHubeauImport,
        type: 'import',
        specify: false,
    },
    {
        value: 'importOmnidia',
        label: i18n.OMNIDIA,
        type: 'import',
        specify: false,
    },
    {
        value: 'quadrige',
        label: i18n.quadrige,
        type: 'import',
        specify: false,
    },
    {
        value: 'distantFtp',
        label: i18n.distantFtp,
        type: 'import',
        withFiles: true,
        specify: false,
    },
    {
        value: 'uploadFtpManually',
        label: i18n.ftpUploadManually,
        type: 'import',
        withFiles: true,
        specify: false,
    },
    {
        value: 'pluvioArea',
        label: i18n.pluvioAreaJob,
        type: 'import',
        specify: true,
    },
    {
        value: 'scriptSSH',
        label: i18n.scriptSSH,
        type: 'import',
        withFiles: true,
        specify: false,
    },
    {
        value: 'era5',
        label: i18n.era5,
        type: 'import',
        specify: true,
    },
    {
        value: 'mfObs',
        label: i18n.mfObs,
        type: 'import',
        specify: true,
    },
    {
        value: 'mfRadar',
        label: i18n.mfRadar,
        type: 'import',
        specify: true,
    },
    {
        value: 'sieauInstance',
        label: i18n.sieauInstance,
        type: 'import',
        specify: false,
    },
    {
        value: 'mailUploadToFtp',
        label: i18n.mailUploadToFtp,
        type: 'import',
        withFiles: true,
        specify: false,
    },
    {
        value: 'veoliaPortalToFtp',
        label: i18n.veoliaPortalToFtp,
        type: 'import',
        withFiles: true,
        specify: false,
    },
    {
        value: 'tapWater',
        label: i18n.tapWater,
        type: 'import',
        specify: true,
    },
    {
        value: 'quesoutAck',
        label: i18n.qesoutAck,
        type: 'export',
        withFiles: true,
        specify: false,
    },
    {
        value: 'quesout',
        label: i18n.quesout,
        type: 'export',
        withFiles: true,
        specify: false,
    },
    {
        value: 'qesoutQualito',
        label: i18n.qesoutQualitoExport,
        type: 'export',
        withFiles: true,
        specify: false,
    },
    {
        value: 'exportQuesu',
        label: i18n.exportQuesu,
        type: 'export',
        specify: false,
    },
    {
        value: 'hydroportailExport',
        label: i18n.hydroportailExport,
        type: 'export',
        withFiles: true,
        specify: false,
    },
    {
        value: 'edilaboExport',
        label: i18n.edilaboExport,
        type: 'export',
        specify: false,
    },
    {
        value: 'qualityResearchStats',
        label: i18n.qualityResearch,
        type: 'export',
        specify: false,
    },
    {
        value: 'postFacebook',
        label: i18n.postFacebook,
        type: 'export',
        specify: false,
    },
    {
        value: 'exportTmpScheduled',
        label: i18n.massExportScheduled,
        type: 'export',
        specify: false,
    },
    {
        value: 'modelCalculationManually',
        label: i18n.modelCalculationManually,
        type: 'calcul',
        specify: false,
    },
    {
        value: 'modelCalculation',
        label: i18n.modelCalculation,
        type: 'calcul',
        specify: false,
    },
    {
        value: 'piezoIndicatorsCalculation',
        label: i18n.piezoIndicatorsCalculation,
        type: 'calcul',
        specify: false,
    },
    {
        value: 'indicatorsCalculation',
        label: i18n.indicatorsCalculation,
        type: 'calcul',
        specify: false,
    },
    {
        value: 'qualityPostControl',
        label: i18n.qualityPostControl,
        type: 'controle',
        specify: false,
    },
    {
        value: 'alertPluvio',
        label: i18n.alertPluvio,
        type: 'alert',
        specify: false,
    },
    {
        value: 'alertHydro',
        label: i18n.alertHydro,
        type: 'alert',
        specify: false,
    },
    {
        value: 'alertPiezo',
        label: i18n.alertPiezo,
        type: 'alert',
        specify: false,
    },
    {
        value: 'outlierQuality',
        label: i18n.outlierQuality,
        type: 'alert',
        specify: false,
    },
    {
        value: 'importMateriel',
        label: i18n.importMateriel,
        type: 'import',
        withFiles: true,
        specify: false,
    },
    {
        value: 'Veolia',
        label: i18n.veolia,
        type: 'import',
        withFiles: true,
        specify: false,
    },
    {
        value: 'importSiapLab',
        label: i18n.importSiapLab,
        type: 'import',
        withFiles: true,
        specify: false,
    },
    {
        value: 'veoliaVolume',
        label: i18n.veoliaVolume,
        type: 'import',
        withFiles: true,
        specify: false,
    },
    {
        value: 'aquadbSelection',
        label: i18n.aquadbSelection,
        type: 'import',
        specify: false,
    },
    {
        value: 'saurVolume',
        label: i18n.saurVolume,
        type: 'import',
        withFiles: true,
        specify: false,
    },
    {
        value: 'calypso',
        label: i18n.calypso,
        type: 'import',
        specify: false,
    },
    {
        value: 'weatherMeasures',
        label: i18n.weatherMeasures,
        type: 'import',
        specify: false,
    },
    {
        value: 'edilaboRai',
        label: i18n.edilaboRai,
        type: 'export',
        specify: false,
    },
    {
        value: 'activity',
        label: i18n.activities,
        type: 'import',
        specify: false,
    },
    {
        value: 'establishment',
        label: i18n.establishment,
        type: 'import',
        specify: false,
    },
    {
        value: 'jobPurgeMateriel',
        label: i18n.purgeMateriel,
        type: 'purge',
        specify: false,
    },
    // {
    //     value: 'jobPurgeQuality',
    //     label: i18n.purgeQuality,
    //     type: 'purge',
    // },
    {
        value: 'purgeStation',
        label: i18n.purgeStationOrQuantityData,
        type: 'purge',
        specify: false,
    },
    {
        value: 'contributorSynchro',
        label: i18n.contributorSynchroLabel,
        type: 'import',
        specify: false,
    },
    {
        value: 'importEtatEco',
        label: i18n.importEtatEco,
        type: 'import',
        specify: false,
    },
    {
        value: 'newslettersGeneration',
        label: i18n.newslettersGeneration,
        type: 'cms',
        description: i18n.usesCmsServiceGenerateNewsletters,
        specify: false,
    },
    {
        value: 'CalculSeee',
        label: i18n.calculSeee,
        type: 'calcul',
        description: i18n.calculSeeeDesc,
        specify: false,
    },
    {
        value: 'materielCompta',
        label: i18n.importMatAccounting,
        type: 'import',
        description: i18n.importMatAccounting,
        specify: false,
    },
    {
        value: 'ArchiveJob',
        label: i18n.ArchiveJob,
        type: 'archive',
        description: i18n.ArchiveJobDesc,
        specify: false,
    },
    {
        value: 'bathingWater',
        label: i18n.bathingWater,
        type: 'import',
        description: i18n.bathingWaterDesc,
        specify: false,
    },
    {
        value: 'alerteClimatic',
        label: i18n.alertClimatic,
        type: 'alert',
        description: i18n.alertClimaticDesc,
        specify: false,
    },
    {
        value: 'perimetersImport',
        label: i18n.perimetersImport,
        type: 'import',
        specify: false,
    },

]

export { IMPORT_FORMATS }